import { AssetsPhotoStubActionable } from '@/services/assets-api/AssetsPhotoService';
import { AssetsResponse, AssetsResponseBulk } from '@/services/assets-api/assetsClient';
import {
  audioMimeTypes,
  documentMimeTypes,
  imageMimeTypes,
  videoMimeTypes,
} from '@/services/assets-api/assetsValidation';
import { extToMime } from '@/services/file/fileProcessor';

export type assetTypes = 'document' | 'image' | 'video' | 'audio';

export const photoRmFilterFn = (photo: AssetsPhotoStubActionable) => photo.image === null && photo.image_id === null
  && photo.drawing === null && photo.drawing_id === null
  && photo.thumbnail === null && photo.thumbnail_id === null;

export const getPhotoImageAndDrawingFiles = (photo: AssetsPhotoStubActionable) => {
  const files = [];
  if (photo.image) {
    files.push({ file: photo.image, name: 'image' });
  }
  if (photo.drawing) {
    files.push({ file: photo.drawing, name: 'drawing' });
  }
  return files;
};

export const fileNameToId = (bulkUploadResult: AssetsResponseBulk) => bulkUploadResult
  .reduce((acc: Record<string, string>, result: AssetsResponse) => {
    acc[result.fileName!] = result.id!;
    return acc;
  }, {});

export const getFileExtension = (fileName: string): string | undefined => /(?:\.([^.]+))?$/.exec(fileName)?.[1];

export const getFileType = (fileName: string): assetTypes | '' => {
  const mime = extToMime(fileName);

  if (imageMimeTypes.includes(mime)) {
    return 'image';
  }
  if (documentMimeTypes.includes(mime)) {
    return 'document';
  }
  if (videoMimeTypes.includes(mime)) {
    return 'video';
  }
  if (audioMimeTypes.includes(mime)) {
    return 'audio';
  }

  return '';
};
